export const FormSingleDatePickerDefProps = {
  date: '',
  onDatesChange: () => {return {date: ''}}
};